import { React, Component, _ } from 'utils';
import { Creators } from 'model';
import './qualifications.less';

export default class LanguagesFilter extends Component {

	handleToggle(key) {

		Creators.toggleFilter({
			filterName: this.props.filterName,
			data: this.props.model,
			key: key
		});
	}

	handleToggleLevel(model, item) {
		Creators.toggleFilter({
			filterName: 'languageLevel',
			data: item,
			key: model
		});
	}

	render() {
		const { model, toggle } = this.props;
		const cls = ['col-md-12'];
		let divStyle = {
			display: 'none',
		};
		if(model.selected) {
			cls.push('selected')
			divStyle = {
				display: 'block',
			};
		}

		const clsL = ['col-md-6 levelStyle'];

		const levels = [
			{name: 'basic', key: 1},
			{name: 'advanced', key: 2},
			{name: 'professional', key: 3},
			{name: 'native', key: 4},
		];

		const levelsList = levels.map((item,index) =>

			<div className={ clsL.join(' ')} id={model.key + '-' + item.key} key={model.key + '-' + item.key}>
				<div className="box-level" onClick={() => this.handleToggleLevel(model.key,item)}>
					<i className="fa fa-check-circle" />
					<div className="name-level">{_(item.name)}</div>
				</div>
			</div>
		);

		return (

			<div>
				<div className={ cls.join(' ') }>
					<div className="box" onClick={() => this.handleToggle(model.key)}>
						<i className="fa fa-check-circle" />
						<div className="name">{_(model.name)}</div>
					</div>
				</div>
				<div style={divStyle} >
					{levelsList}
				</div>

			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/filters/LanguagesFilter.js